import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionMotivationPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-almost-there')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionMotivation.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionMotivation.stressRelief'),
          value: 'stress_relief',
        },
        {
          text: t('pages.onboarding.questionMotivation.improvingDecor'),
          value: 'improving_decor',
        },
        {
          text: t('pages.onboarding.questionMotivation.environmentalBenefits'),
          value: 'environmental_benefits',
        },
        {
          text: t('pages.onboarding.questionMotivation.mindfulnessHobby'),
          value: 'mindfulness_hobby',
        },
        {
          text: t('pages.onboarding.questionMotivation.loveOfNature'),
          value: 'love_of_nature',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
